import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const UserPermissionsList = ({ modules, headingText }) => {
  const renderPermissions = (moduleId, permissions) => {
    const domElem = _.map(permissions, permission => {
      const { id, name } = permission;
      return (
        <div key={`${moduleId}_${name}_${id}`} className="accounts-role-feature--checkbox">
          <input
            type="checkbox"
            id={`${moduleId}_${name}_${id}`}
            name={`${moduleId}_${name}_${id}`}
            checked
            disabled
          />
          <label htmlFor={`${moduleId}_${name}_${id}`}>
            <span className="accounts-role-feature--name crosstab-icon">
              {name}
            </span>
          </label>
        </div>
      );
    });
    return domElem;
  };

  const renderFeatures = () => {
    if (_.isEmpty(modules)) {
      return (
        <div className="no-permission">No permissions assigned to this role.</div>
      );
    }
    const domElem = _.map(modules, feature => {
      const { moduleName, moduleId, permissions } = feature;
      return (
        <div key={`${moduleName}_${moduleId}`} className="accounts-role-feature">
          <div className="accounts-role-feature--header">
            <div className="accounts-role-feature--checkbox">
              <input
                type="checkbox"
                id={`roleFeature${moduleName}`}
                name={`roleFeature${moduleName}`}
                checked
                disabled
              />
              <label htmlFor={`roleFeature${moduleName}`}>
                <span className={`accounts-role-feature--name ${moduleName.toLowerCase()}_icon`}>{moduleName}</span>
              </label>
            </div>
          </div>
          <div className="accounts-role-feature--list">
            {renderPermissions(moduleId, permissions)}
          </div>
        </div>
      );
    });
    return domElem;
  };

  return (
    <div className="user-roles--items">
      {headingText && <div className="user-roles--items-header">{headingText}</div> }
      <div className="accounts-role-features-box">
        <div className="accounts-role-features">
          {renderFeatures()}
        </div>
      </div>
    </div>
  );
};

UserPermissionsList.propTypes = {
  modules: PropTypes.instanceOf(Array),
  headingText: PropTypes.string,
};

UserPermissionsList.defaultProps = {
  modules: [],
  headingText: '',
};

export default UserPermissionsList;
